/*
 * MY01 | by marwanyousef.com
 * Shared storefront helpers: money formatting, variant picking,
 * AJAX add-to-cart wired into Dawn's existing cart drawer / notification,
 * free-shipping progress bar and cart upsell.
 */
(function () {
  if (window.My01) return;

  var cfg = window.My01Config || {};

  /* ---------------- Money ---------------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = parseInt(cents, 10) || 0;
    format = format || cfg.moneyFormat || '${{amount}}';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;

    function withDelimiters(number, precision, thousands, decimal) {
      thousands = thousands === undefined ? ',' : thousands;
      decimal = decimal === undefined ? '.' : decimal;
      if (isNaN(number) || number == null) return '0';
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsPart = parts[1] ? decimal + parts[1] : '';
      return dollars + centsPart;
    }

    var match = format.match(placeholder);
    if (!match) return format;
    var value;
    switch (match[1]) {
      case 'amount': value = withDelimiters(cents, 2); break;
      case 'amount_no_decimals': value = withDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = withDelimiters(cents, 2, "'", '.'); break;
      case 'amount_with_space_separator': value = withDelimiters(cents, 2, ' ', ','); break;
      default: value = withDelimiters(cents, 2);
    }
    return format.replace(placeholder, value);
  }

  /* ---------------- Product data helpers ---------------- */
  function optionNames(product) {
    return (product.options || []).map(function (o) {
      return typeof o === 'string' ? o : o.name;
    });
  }

  function optionValues(product, index) {
    var seen = [];
    (product.variants || []).forEach(function (v) {
      var val = v.options ? v.options[index] : v['option' + (index + 1)];
      if (val != null && seen.indexOf(val) === -1) seen.push(val);
    });
    return seen;
  }

  function variantOptions(v) {
    return v.options || [v.option1, v.option2, v.option3].filter(function (x) { return x != null; });
  }

  function hasOnlyDefault(product) {
    var vs = product.variants || [];
    return vs.length === 1 && /default title/i.test(vs[0].title || '');
  }

  function findVariant(product, selected) {
    return (product.variants || []).find(function (v) {
      var o = variantOptions(v);
      return selected.every(function (s, i) { return s == null || o[i] === s; }) &&
        selected.every(function (s) { return s != null; });
    }) || null;
  }

  /* Is value `val` at option `index` purchasable given the other selections? */
  function valueAvailable(product, selected, index, val) {
    return (product.variants || []).some(function (v) {
      if (!v.available) return false;
      var o = variantOptions(v);
      if (o[index] !== val) return false;
      return selected.every(function (s, i) { return i === index || s == null || o[i] === s; });
    });
  }

  /*
   * Renders clickable option buttons into `container`.
   * onChange(variant|null, selected[]) fires on every click.
   */
  function VariantButtons(container, product, opts) {
    opts = opts || {};
    this.container = container;
    this.product = product;
    this.names = optionNames(product);
    this.selected = this.names.map(function () { return null; });
    this.onChange = opts.onChange || function () {};
    this.showLabels = opts.showLabels !== false && this.names.length > 1;
    this.swatches = !!opts.swatches;

    // Pre-select options that only have a single value (e.g. one colour)
    var self = this;
    this.names.forEach(function (n, i) {
      var vals = optionValues(product, i);
      if (vals.length === 1) self.selected[i] = vals[0];
    });
    if (opts.preselect) {
      var o = variantOptions(opts.preselect);
      this.selected = this.names.map(function (n, i) { return o[i]; });
    }
    this.render();
  }

  VariantButtons.prototype.render = function () {
    var self = this;
    var html = '';
    this.names.forEach(function (name, i) {
      var vals = optionValues(self.product, i);
      if (vals.length < 2 && self.names.length > 1) return; // single value: pre-selected, hidden
      html += '<div class="my01-opt" role="radiogroup" aria-label="' + escapeHtml(name) + '">';
      if (self.showLabels) html += '<span class="my01-opt__label">' + escapeHtml(name) + '</span>';
      html += '<div class="my01-opt__values">';
      var isColor = self.swatches && /colou?r/i.test(name);
      vals.forEach(function (val) {
        var avail = valueAvailable(self.product, self.selected, i, val);
        var active = self.selected[i] === val;
        var swatch = isColor ? '<span class="my01-opt__swatch" style="background:' + String(val).toLowerCase().replace(/[^a-z0-9#]/g, '') + '" aria-hidden="true"></span>' : '';
        html += '<button type="button" class="my01-opt__btn' + (active ? ' is-active' : '') +
          (avail ? '' : ' is-unavailable') + '" role="radio" aria-checked="' + active +
          '" data-index="' + i + '" data-value="' + escapeHtml(val) + '"' +
          (avail ? '' : ' aria-disabled="true"') + '>' + swatch + escapeHtml(val) + '</button>';
      });
      html += '</div></div>';
    });
    this.container.innerHTML = html;
    this.container.querySelectorAll('.my01-opt__btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.classList.contains('is-unavailable')) return;
        var i = parseInt(btn.dataset.index, 10);
        self.selected[i] = btn.dataset.value;
        // Drop other selections that are no longer purchasable
        self.selected = self.selected.map(function (s, j) {
          if (j === i || s == null) return s;
          return valueAvailable(self.product, self.selected, j, s) ? s : (optionValues(self.product, j).length === 1 ? s : null);
        });
        self.render();
        var focusBtn = self.container.querySelector('.my01-opt__btn[data-index="' + i + '"][data-value="' + cssEscape(btn.dataset.value) + '"]');
        if (focusBtn) focusBtn.focus();
        self.onChange(self.variant(), self.selected.slice());
      });
    });
  };

  VariantButtons.prototype.variant = function () {
    return findVariant(this.product, this.selected);
  };

  VariantButtons.prototype.isComplete = function () {
    return this.selected.every(function (s) { return s != null; });
  };

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function cssEscape(s) {
    return window.CSS && CSS.escape ? CSS.escape(s) : String(s).replace(/"/g, '\\"');
  }

  /* ---------------- Cart ---------------- */
  var busy = false;

  function cartTarget() {
    return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
  }

  function addToCart(items, opts) {
    opts = opts || {};
    if (busy) return Promise.reject(new Error('busy'));
    busy = true;
    items = Array.isArray(items) ? items : [items];
    var target = cartTarget();
    var body = { items: items.map(function (it) { return { id: Number(it.id), quantity: Number(it.quantity || 1) }; }) };
    if (target && typeof target.getSectionsToRender === 'function') {
      body.sections = target.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }
    var url = ((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js';

    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    })
      .then(function (res) {
        return res.json().then(function (data) { return { ok: res.ok, data: data }; });
      })
      .then(function (r) {
        var data = r.data;
        if (!r.ok || data.status) {
          var msg = data.description || data.message || (window.cartStrings && window.cartStrings.error) || 'Error';
          if (typeof publish === 'function' && window.PUB_SUB_EVENTS) {
            publish(PUB_SUB_EVENTS.cartError, { source: 'my01', productVariantId: body.items[0].id, errors: msg, message: msg });
          }
          throw new Error(msg);
        }
        if (typeof publish === 'function' && window.PUB_SUB_EVENTS) {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'my01', productVariantId: body.items[0].id, cartData: data });
        }
        if (opts.silent) {
          // Caller handles what happens next (e.g. Buy it now → checkout)
        } else if (target && typeof target.renderContents === 'function' && data.sections) {
          if (target.classList.contains('is-empty')) target.classList.remove('is-empty');
          var first = (data.items && data.items[0]) || data;
          var state = Object.assign({}, first, { sections: data.sections });
          target.renderContents(state);
        } else if (cfg.cartType === 'page' || !target) {
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        }
        document.dispatchEvent(new CustomEvent('my01:cart:added', { detail: data }));
        return data;
      })
      .finally(function () { busy = false; });
  }

  /* ---------------- Free shipping bar (currency aware) ---------------- */
  function refreshShippingBars(root) {
    (root || document).querySelectorAll('[data-my01-shipping]').forEach(function (bar) {
      var base = parseInt(bar.dataset.threshold, 10) || 0; // shop currency cents
      var rate = (window.Shopify && Shopify.currency && parseFloat(Shopify.currency.rate)) || 1;
      var threshold = Math.round(base * rate);
      var total = parseInt(bar.dataset.total, 10) || 0;
      if (threshold <= 0) return;
      var remaining = Math.max(threshold - total, 0);
      var pct = Math.min(100, Math.round((total / threshold) * 100));
      var fill = bar.querySelector('.my01-ship__fill');
      var text = bar.querySelector('.my01-ship__text');
      if (fill) fill.style.width = pct + '%';
      bar.classList.toggle('is-complete', remaining === 0);
      if (text) {
        text.innerHTML = remaining === 0
          ? bar.dataset.success
          : bar.dataset.message.replace('[amount]', '<strong>' + formatMoney(remaining) + '</strong>');
      }
    });
  }

  /* ---------------- Upsell (event delegation survives drawer re-renders) ---------------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-my01-upsell-add]');
    if (!btn) return;
    e.preventDefault();
    var card = btn.closest('.my01-upsell__item');
    var select = card && card.querySelector('select');
    var id = select ? select.value : btn.dataset.variantId;
    if (!id) return;
    btn.classList.add('is-loading');
    btn.setAttribute('aria-busy', 'true');
    addToCart({ id: id, quantity: 1 })
      .catch(function (err) {
        if (err.message === 'busy') return;
        var errEl = card && card.querySelector('.my01-upsell__error');
        if (errEl) errEl.textContent = err.message;
      })
      .finally(function () {
        btn.classList.remove('is-loading');
        btn.removeAttribute('aria-busy');
      });
  });

function watchDrawer() {
  var drawer = document.querySelector('cart-drawer');
  refreshShippingBars();

  if (!drawer || !window.MutationObserver) return;

  var observer = new MutationObserver(function () {
    observer.disconnect();

    try {
      refreshShippingBars(drawer);
    } finally {
      observer.observe(drawer, {
        childList: true,
        subtree: true
      });
    }
  });

  observer.observe(drawer, {
    childList: true,
    subtree: true
  });
}


  /* Keep the header's custom text label (e.g. BAG+) after Dawn re-renders #cart-icon-bubble */
  function keepCartLabel() {
    var bubble = document.getElementById('cart-icon-bubble');
    if (!bubble || !window.MutationObserver) return;
    var labels = Array.from(bubble.querySelectorAll('.header__cart-text')).map(function (n) { return n.cloneNode(true); });
    if (!labels.length) return;
    var restoring = false;
    new MutationObserver(function () {
      if (restoring || bubble.querySelector('.header__cart-text')) return;
      restoring = true;
      labels.forEach(function (l) { bubble.appendChild(l.cloneNode(true)); });
      restoring = false;
    }).observe(bubble, { childList: true });
  }

  function init() { watchDrawer(); keepCartLabel(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  /* Lock page scroll for MY01 modals */
  var locks = 0;
  function lockScroll(on) {
    locks = Math.max(0, locks + (on ? 1 : -1));
    document.documentElement.classList.toggle('my01-scroll-lock', locks > 0);
  }

  window.My01 = {
    formatMoney: formatMoney,
    VariantButtons: VariantButtons,
    hasOnlyDefault: hasOnlyDefault,
    optionNames: optionNames,
    addToCart: addToCart,
    refreshShippingBars: refreshShippingBars,
    lockScroll: lockScroll,
    escapeHtml: escapeHtml
  };
})();
